import { motion } from 'framer-motion';
import { LayoutGridIcon, SparklesIcon, ShieldCheckIcon, FeatherIcon, GemIcon, StarIcon } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/q7RnjxXyHz353QdkW84P8k/IMG_5459.jpg';
const EDITORIAL_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/3cb4e42c-8a01-41c1-bc2f-8f636dc11d78.jpg';
const KIT_ROSADO_URL = 'https://e04whn-0h.myshopify.com/products/kit-rosado-premium-para-extensiones-de-pestanas';
const KIT_NEGRO_URL = 'https://e04whn-0h.myshopify.com/products/kit-negro-premium-para-extensiones-de-pestanas';
const GOLD = '#C9A96E';
const benefits = [{
  icon: LayoutGridIcon,
  title: 'Organización inteligente',
  text: 'Todo en su lugar para trabajar con mayor rapidez.'
}, {
  icon: SparklesIcon,
  title: 'Elegancia profesional',
  text: 'Un diseño sofisticado que refleja la calidad de tu trabajo.'
}, {
  icon: ShieldCheckIcon,
  title: 'Protección de tus herramientas',
  text: 'Compartimentos diseñados para mantener cada accesorio seguro.'
}, {
  icon: FeatherIcon,
  title: 'Comodidad diaria',
  text: 'Ligero, práctico y fácil de transportar a cualquier cita.'
}, {
  icon: GemIcon,
  title: 'Materiales Premium',
  text: 'Fabricado con acabados elegantes y resistentes para el uso diario.'
}, {
  icon: StarIcon,
  title: 'Diseñado para destacar',
  text: 'Porque la presentación también forma parte de la experiencia del cliente.'
}];
export function ShopifyDescription() {
  return <section className="relative overflow-hidden px-5 sm:px-6 py-16 sm:py-24 lg:py-32" style={{
    background: 'linear-gradient(180deg, #ffffff 0%, #fdfbf7 50%, #ffffff 100%)'
  }} data-id="element-362" data-mp="2i6i80u3udrq1">
      {/* Brand watermark */}
      <img src={LOGO_URL} alt="" aria-hidden="true" className="pointer-events-none select-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[85%] max-w-[900px] mix-blend-multiply opacity-[0.07] z-0" data-id="element-363" data-mp="2dt3j470tuu9" />

      <div className="relative z-10 max-w-6xl mx-auto" data-id="element-364" data-mp="4weevrsvscfl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-20 items-start" data-id="element-365" data-mp="vud2axd4kn4">
          {/* Left — editorial photograph */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.9
        }} className="lg:sticky lg:top-24" data-id="element-366" data-mp="3s5azbb7vs34w">
            <img src={EDITORIAL_IMAGE} alt="Lash artist profesional con su kit Alexa Beauty en un estudio de extensiones de pestañas" loading="lazy" decoding="async" className="w-full h-auto object-cover rounded-sm" data-id="element-367" data-mp="jn52ennfwpcw" />
            <p className="mt-6 text-xs tracking-[0.25em] uppercase text-gray-400 font-sans" data-id="element-368" data-mp="17d958sst0l2u">
              El kit como parte de tu forma de trabajar
            </p>
          </motion.div>

          {/* Right — persuasive content */}
          <div data-id="element-369" data-mp="19yyu54e0rari">
            <motion.div initial={{
            opacity: 0,
            y: 24
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-370" data-mp="19zicgm7l0162">
              <span className="text-xs font-medium tracking-[0.3em] uppercase block mb-6" style={{
              color: GOLD
            }} data-id="element-371" data-mp="1ouoi382rlxyv">
                Información del Producto
              </span>

              <h2 className="text-3xl md:text-4xl font-serif text-luxury-black leading-tight mb-8" data-id="element-372" data-mp="1xul04qunfyky">
                Más que un kit. Una herramienta para elevar tu imagen
                profesional.
              </h2>

              <p className="text-base md:text-lg text-gray-600 font-sans font-light leading-relaxed" data-id="element-373" data-mp="27jus86phth92">
                No todas las profesionales utilizan las mismas herramientas. Las
                mejores eligen productos que transmiten organización, elegancia
                y confianza desde el primer momento.
              </p>
            </motion.div>

            {/* Body copy */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.15
          }} className="mt-8 sm:mt-12 space-y-5 text-base text-gray-600 font-sans font-light leading-relaxed" data-id="element-374" data-mp="39akxovisvnb2">
              <p data-id="element-375" data-mp="2vdz3pvm22ilx">
                Cada cliente percibe los pequeños detalles. Llegar con un kit
                elegante, bien organizado y diseñado para proteger tus
                herramientas también comunica profesionalismo.
              </p>
              <p data-id="element-376" data-mp="2zd6qznmoicvy">
                Alexa Beauty fue creado para lash artists y profesionales de la
                belleza que quieren ofrecer una experiencia impecable en cada
                cita.
              </p>
              <p className="text-luxury-black" data-id="element-377" data-mp="emfq6b3f8k6r">
                Porque una imagen profesional comienza mucho antes de iniciar el
                servicio.
              </p>
            </motion.div>

            {/* Benefits grid */}
            <div className="mt-10 sm:mt-14 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-8 sm:gap-y-10" data-id="element-378" data-mp="r3qk6tp04q9e">
              {benefits.map(({
              icon: Icon,
              title,
              text
            }, index) => <motion.div key={title} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.6,
              delay: index % 2 * 0.1
            }} className="flex items-start gap-4" data-id="element-379" data-mp="i5oliksqq9pa" data-mpi={index}>
                  <Icon className="w-5 h-5 shrink-0 mt-1" style={{
                color: GOLD
              }} aria-hidden="true" data-id="element-380" data-mp="113r34eiyl4d2" />
                  <div data-id="element-381" data-mp="1tkbmicnfx1tl">
                    <h3 className="font-serif text-lg text-luxury-black mb-2" data-id="element-382" data-mp="1tktu25fjz2gt">
                      {title}
                    </h3>
                    <p className="text-sm text-gray-500 font-sans font-light leading-relaxed" data-id="element-383" data-mp="23fs9vaoz9fj4">
                      {text}
                    </p>
                  </div>
                </motion.div>)}
            </div>

            {/* Color selector */}
            <motion.div id="disponible-en" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7
          }} className="mt-12 sm:mt-16 scroll-mt-24" data-id="element-384" data-mp="1phaqtqa0or7j">
              <p className="font-serif text-xl md:text-2xl text-luxury-black mb-8" data-id="element-385" data-mp="1aqv76fx91rbh">
                Elige el estilo que mejor representa tu marca.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center" data-id="element-386" data-mp="11qykukyc14jl">
                <a href={KIT_ROSADO_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-rosado-soft px-4 py-2 rounded-full text-sm text-luxury-black border border-rosado-light/50" data-id="element-387" data-mp="11srlnjm9kujo">
                  🌸 Rosado Premium
                </a>
                <a href={KIT_NEGRO_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-luxury-black px-4 py-2 rounded-full text-sm text-white" data-id="element-388" data-mp="3hgewdkkg02qr">
                  🖤 Negro Luxury
                </a>
              </div>
            </motion.div>
          </div>
        </div>

        {/* Emotional statement */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 1
      }} className="mt-16 sm:mt-24 text-center" data-id="element-389" data-mp="33g454gf80m52">
          <p className="font-serif italic text-xl md:text-3xl text-luxury-black leading-relaxed max-w-2xl mx-auto" data-id="element-390" data-mp="2az1kf797zk9r">
            "La confianza de tus clientes comienza con la imagen que proyectas."
          </p>

          <motion.div initial={{
          scaleX: 0
        }} whileInView={{
          scaleX: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.9,
          delay: 0.3
        }} className="mx-auto mt-10 h-[1px] w-24 origin-center" style={{
          backgroundColor: GOLD
        }} data-id="element-391" data-mp="zefrrqlci9w8" />
        </motion.div>
      </div>
    </section>;
}